<template>
    <div class="type-cell" @click="showModal">
        {{ displayValue }}
    </div>
</template>

<script>
import dayjs from 'dayjs';
import Vue from 'vue';
import FileTypeModal from '../../Modal/FileTypeModal';
import riskhub from '@/services/Riskhub/Riskhub';

export default Vue.extend({
  computed: {
    displayValue(params) {
      const { value } = params.params;

      if (value === params.params.data.type) {
        return value;
      }

      return riskhub.formatDate(value);
    },
  },
  methods: {
    showModal() {
      const propertyDocumentId = this.params.data.propertyFileId;
      const { propertyId } = this.params.data;

      this.params.context.componentParent.openFileTypeModal(propertyDocumentId, propertyId);
    },
  },
});
</script>

<style lang="scss" scoped>
    .type-cell {
        min-height: 45px; // with out this, we cannot click empty cells
    }
</style>
